import styled, { css, keyframes } from 'styled-components'

const shimmer = keyframes`
  0% {
    background-position: -200% center;
  }
  100% {
    background-position: 200% center;
  }
`

export const AIGlowText = styled.span<{ displayGlow?: boolean }>`

 // Temporary colours until design comes up with what colours they want
  ${props => props.displayGlow && css`
    display: block;
    background: linear-gradient(
      90deg,
      #A855F7 0%,
      #6366F1 25%,
      #A855F7 50%,
      #6366F1 75%,
      #A855F7 100%
    );
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: ${shimmer} 3s linear infinite;
    font-weight: 600;
  `}
`

export default AIGlowText
